
import React, { useState, useEffect } from 'react';
import css from './AddToFavoritesButton.module.css';
import FavoriteOnIcon from '@mui/icons-material/Favorite';
import FavoriteOffIcon from '@mui/icons-material/FavoriteBorder';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { IconSpinner } from '..';

const sharetribeSdk = require('sharetribe-flex-sdk');
const sdk = sharetribeSdk.createInstance({
    clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID,
});

const AddToFavoritesButtonComponent = props => {
    const { listingIdObj, currentUser, isOwnListing, history, onUpdateCurrentUser, onRemoveFavorite } = props;

    if (isOwnListing) {
        return null;
    }
    const listingId = listingIdObj.uuid;
    const [isFavorite, setIsFavorite] = useState(false);
    const [isBusy, setIsBusy] = useState(false);

    useEffect(() => {
        if (currentUser?.id?.uuid) {
            if (
                currentUser.attributes.profile.privateData &&
                currentUser.attributes.profile.privateData.favorites
            ) {
                const listingsIdsArray = currentUser.attributes.profile.privateData.favorites;
                const isFavorite = listingsIdsArray.find(id => {
                    return id === listingId;
                });
                if (isFavorite) {
                    setIsFavorite(true);
                }
            }
        }
    }, [currentUser?.id?.uuid]);

    const AddToFavorites = action => {
        setIsBusy(true);
        if (!currentUser?.id?.uuid) {
            return history.push('/login');
        }
        if (!listingIdObj || !currentUser?.id?.uuid) {
            return null;
        }
        return sdk.currentUser
            .show()
            .then(res => {
                const currentFavorites =
                    res?.data?.data?.attributes?.profile?.privateData?.favorites || [];

                if (currentFavorites.find(f => f === listingId) && action === 'add') {
                    setIsBusy(false);
                    return setIsFavorite(true);
                }

                if (action === 'add') {
                    return sdk.currentUser
                        .updateProfile({
                            privateData: {
                                favorites: [...currentFavorites, listingId],
                            },
                        })
                        .then(resp => {
                            onUpdateCurrentUser();
                            setIsBusy(false);
                            return setIsFavorite(true);
                        })
                        .catch(e => {
                            console.log(e)
                            setIsBusy(false);
                        });
                } else {
                    const newFavorites = [...currentFavorites].filter(id => id !== listingId);

                    return sdk.currentUser
                        .updateProfile({
                            privateData: {
                                favorites: newFavorites,
                            },
                        })
                        .then(resp => {
                            onUpdateCurrentUser();

                            if (onRemoveFavorite) {
                                onRemoveFavorite();
                            }
                            setIsBusy(false);
                            return setIsFavorite(false);
                        })
                        .catch(e => {
                            console.log(e)
                            setIsBusy(false);
                        });
                }
            })
            .catch(e => {
                console.log(e)
                setIsBusy(false);
            });
    };

    return (
        <div className={css.favoritesButtonWrapper}>

            {isBusy ? <IconSpinner />
                :
                !isFavorite ? (
                    <FavoriteOffIcon
                        onClick={e => {
                            e.stopPropagation();
                            e.preventDefault();
                            AddToFavorites('add');
                        }}
                        className={css.favoritesButtonNotSelected}
                    />
                ) : (
                    <FavoriteOnIcon
                        onClick={e => {
                            e.stopPropagation();
                            e.preventDefault();
                            AddToFavorites('remove');
                        }}
                        className={css.favoritesButtonSelected}
                    />
                )
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {};
};

const mapDispatchToProps = dispatch => ({
    onUpdateCurrentUser: () => dispatch(fetchCurrentUser())
});

const AddToFavoritesButton = compose(
    withRouter,
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    injectIntl
)(AddToFavoritesButtonComponent);

export default AddToFavoritesButton;